import { Link } from 'react-router-dom';

const Navbar = () => (
  <nav>
    <div className="navcontent">
      <div className="logo">leigh.devs</div>
      <div className="right">
        <Link className="home" to="/">Home</Link>
        <Link className="playnow" to="/Play">Play Now</Link>
      </div>
    </div>
  </nav>
);

export default Navbar;
